import { TagsView as View } from 'ui-components'

import { useSearchTags } from '~map-tags/queries/useSearchTags'
import { Tag } from '~map-tags/types/__generated/gql/graphql'

export function TagsView() {
  const { data } = useSearchTags()

  return <View items={(data?.items || []) as Tag[]} />
}
